const BASE_URL = '/v2/trade-data-agreement'

export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get(`${BASE_URL}/list-agreements`)
}

export function getOptionAgreements(axiosPrivate) {
  return axiosPrivate.get(`${BASE_URL}/options`)
}

export function getChapterReviewById(axiosPrivate, params) {
  const id = params.idReview
  return axiosPrivate.get(`${BASE_URL}/review-chapter/${id}`)
}

export function getParentChapters(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`${BASE_URL}/parent-chapters/${id}`)
}

export function postChapterReview(axiosPrivate, id, body) {
  return axiosPrivate.post(`${BASE_URL}/review-chapter/${id}`, body)
}

export function deleteChapterReview(axiosPrivate, id) {
  return axiosPrivate.delete(`${BASE_URL}/review-chapter/${id}`)
}

export function verifySourceUrl(axiosPrivate, url) {
  return axiosPrivate.post(`${BASE_URL}/verify-source-url`, {url})
}
